import { combineReducers } from "redux"
import { MainReducer } from "./MainReducer"
import { StatRusReducer } from "./StatRusReducer";
import { MonoReducer } from "./MonoReducer";






export const rootReducer = combineReducers( {
   Main:MainReducer,
   StatRus: StatRusReducer,
   Mono: MonoReducer
  
})

// Для того щоб вицепити стейт
export type RootState = ReturnType<typeof rootReducer>